// tslint:disable
export var MedicalBiGender;
(function (MedicalBiGender) {
    MedicalBiGender["Male"] = "m";
    MedicalBiGender["Female"] = "f";
    MedicalBiGender["Unknown"] = "u";
})(MedicalBiGender || (MedicalBiGender = {}));
//# sourceMappingURL=MedicalBiGender.js.map